import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  ChannelSchema,
  ChannelWithInformationSchema,
  LineChannelCreateResponseSchema,
  LineWebhookCheckSchema,
} from "../models";

/**
 * This API is used to manage line channels. API will be deprecated once
 * the migration from MAAC to the admin center is completed.
 */
const api = makeApi([
  {
    /**
     * Spec: [Notion](https://www.notion.so/cresclab/202505-Channel-Migration-1df8ce1589388088b002c420722b6199?pvs=4#1ed8ce15893880999e8bcf146512cbfb)
     */
    alias: "channels",
    method: "get",
    path: "/api/v1/channels/line/info",
    response: z.object({
      channels: ChannelWithInformationSchema.array(),
    }),
  },
  {
    /**
     * Spec: [Notion](https://www.notion.so/cresclab/202505-Channel-Migration-1df8ce1589388088b002c420722b6199?pvs=4#1ed8ce158938805c9330f136d7fc96b0)
     */
    alias: "getByUuid",
    method: "get",
    path: "/api/v1/channels/line/:channelUuid",
    parameters: [
      {
        type: "Path",
        name: "channelUuid",
        schema: ChannelSchema.shape.uuid,
      },
    ],
    response: ChannelWithInformationSchema,
  },
  {
    /**
     * Spec: [Notion](https://www.notion.so/cresclab/202505-Channel-Migration-1df8ce1589388088b002c420722b6199?pvs=4#1ed8ce1589388070a11cd28a922d096d)
     */
    alias: "updateChannel",
    method: "patch",
    path: "/api/v1/channels/line/:channelUuid",
    parameters: [
      {
        type: "Path",
        name: "channelUuid",
        schema: ChannelSchema.shape.uuid,
      },
      {
        type: "Body",
        name: "body",
        schema: z.object({
          name: ChannelSchema.shape.name,
        }),
      },
    ],
    response: ChannelWithInformationSchema,
  },
  {
    /**
     * Spec: interlude#1362. Connects a LINE OA by its Messaging API channel ID
     * and secret.
     */
    alias: "createChannel",
    method: "post",
    path: "/api/v1/channels/line",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          /** "Channel ID" from the LINE Developers console (Messaging API). */
          externalChannelId: z.string().min(1),
          /** "Channel secret" from the same console page. */
          externalChannelSecret: z.string().min(1),
        }),
      },
    ],
    response: LineChannelCreateResponseSchema,
  },
  {
    /**
     * Spec: interlude#1362. Checks LINE's "Use webhook" switch for this
     * channel and tries to repair it, so it is a POST.
     */
    alias: "checkWebhook",
    method: "post",
    path: "/api/v1/channels/line/:channelUuid/webhook-check",
    parameters: [
      {
        type: "Path",
        name: "channelUuid",
        schema: ChannelSchema.shape.uuid,
      },
    ],
    response: LineWebhookCheckSchema,
  },
]);

export { api };
